mutation DisconnectDomain {
  disconnectDomain {
    id
    host
    domainSetup {
      host
      status
      zoneName
      lastError
      updatedAt
      activatedAt
    }
  }
}
